import script from "./TranscriptView.vue?vue&type=script&setup=true&lang=js"
export * from "./TranscriptView.vue?vue&type=script&setup=true&lang=js"

import "./TranscriptView.vue?vue&type=style&index=0&id=47f99424&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f99424"]])

export default __exports__